import MobileFoodCarousel from "src/components/common/MobileFoodCarousel";
import { Typography, Box } from "@mui/material";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { foodImageSource } from "src/config/foodImage";
import FoodCard from "src/views/menu/components/FoodCard/FoodCard";
import { motion } from "framer-motion";

const itemImageFallback = "/uploads/item_image/82accee4-e475-4af5-9fe8-728b4ec06e9a.jpg";

function HomeThirdSection() {
  const joinData = useSelector((state) => state.menus.joinData);

  // -------------------------------
  // 👍 SAFE POPULAR FILTER
  // -------------------------------
  const popularItems = useMemo(() => {
    try {
      return (
        joinData?.[0]?.filter((fooditem) => {
          try {
            const parsedPopular =
              typeof fooditem.item_popular === "string"
                ? JSON.parse(fooditem.item_popular)
                : fooditem.item_popular;

            return (
              Array.isArray(parsedPopular) &&
              parsedPopular.some((p) => p.status === true)
            );
          } catch {
            return false;
          }
        }) || []
      );
    } catch {
      return [];
    }
  }, [joinData]);

  // -------------------------------
  // 👍 PREPARE ITEMS (price + image)
  // -------------------------------
  const preparedItems = useMemo(() => {
    return popularItems.map((fooditem) => {
      // ---- SAFE PRICE ----
      let price = 0;
      try {
        const parsed =
          typeof fooditem.item_price === "string"
            ? JSON.parse(fooditem.item_price)
            : fooditem.item_price;
        price = parsed?.[0] || 0;
      } catch {
        price = 0;
      }

      const imageSrc = foodImageSource(fooditem.item_image, fooditem.mimeType) || itemImageFallback;

      return {
        ...fooditem,
        price,
        imageSrc,
      };
    });
  }, [popularItems]);

  return (
    <Box sx={{ px: { xs: 1, sm: 3 }, pt: { xs: 2, sm: 2.5 }, pb: { xs: 2, sm: 3 }, borderRadius: 0, background: "transparent" }}>
      <Box sx={{ position: "relative", display: "flex", justifyContent: "center", mb: 3 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography sx={{ color: "#b58519", fontSize: "0.68rem", fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase" }}>
            From our kitchen
          </Typography>
          <Typography className="responsive_fontsize24" sx={{ fontFamily: "Roboto Serif", fontWeight: 700, color: "#252920", letterSpacing: "-0.02em", mt: 0.5 }}>
            Popular dishes
          </Typography>
          <Typography sx={{ color: "#747767", mt: 0.5, fontSize: "0.9rem" }}>
            Chef-loved dishes, made fresh for your table
          </Typography>
        </Box>
        <Typography sx={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)", display: { xs: "none", sm: "block" }, color: "#7f8c61", fontSize: "0.76rem", fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>
          Fresh today
        </Typography>
      </Box>

      {/* RESPONSIVE GRID */}
      <MobileFoodCarousel
        sx={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: {
            xs: 1,
            sm: 2,
            md: 3,
          },
        }}
      >
        {preparedItems.length > 0 ? (
          preparedItems.map((fooditem) => (
            <Box
              key={fooditem.item_id}
              component={motion.div}
              initial={{ opacity: 0, y: 28, scale: 0.96 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: Math.min(preparedItems.indexOf(fooditem) * 0.08, 0.4) }}
              sx={{
                width: { xs: "100%", sm: 230, md: 260, lg: 280 },
              }}
            >
              <FoodCard
                fooditem={fooditem}
                image={fooditem.imageSrc || itemImageFallback}
                showFavorite={false}
                fullWidth
              />
            </Box>
          ))
        ) : (
          <Typography
          className="responsive_fontsize16"
            sx={{
              fontFamily: "Roboto Serif",
              fontWeight: 500,
              textAlign: "center",
              // mt: 4,
              color: "gray",
            }}
          >
            Popular items will be available soon...
          </Typography>
        )}
      </MobileFoodCarousel>
    </Box>
  );
}

export default HomeThirdSection;
